import { render, staticRenderFns } from "./BankCommodities.vue?vue&type=template&id=52b37479&"
import script from "./BankCommodities.vue?vue&type=script&lang=js&"
export * from "./BankCommodities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports